import { send } from "./GoogleAnalyticsClient";
import { GTM_EVENT as GTMEvent, GA_CATEGORIES as CATEGORIES } from "../../../constants";
import { RefillPackage } from "../../../models/state";
const PRODUCT_CATEGORY = CATEGORIES.SUBSCRIPTION_PREPAID_REFILL;
const BRAND = "Telia";

export const trackRefillProductClick = (refillPackage: RefillPackage): Promise<unknown> =>
    send({
        event: GTMEvent.PRODUCT_CLICK,
        ecommerce: {
            click: {
                actionField: { list: PRODUCT_CATEGORY },
                products: [
                    {
                        brand: BRAND,
                        category: PRODUCT_CATEGORY,
                        id: `${refillPackage.code}`,
                        name: refillPackage.name,
                        price: refillPackage.price,
                        variant: refillPackage.duration,
                        quantity: 1,
                    },
                ],
            },
        },
    });
